export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/crm/crm.jpg'),
        title: 'ProphetCRM',
        description: '中国のお客様の海外進出を支援します',
        component: ''
      }
  ],
  step1:{
    title: '中小企業のデジタルトランスフォーメーションを支援し、データで顧客を発掘・サービス・保持します',
    description: `ProphetCRMは中国のお客様の海外展開を支援するとともに、海外のお客様の中国市場参入もサポートします`,
    cases: [
      { title: '豊富な海外プロジェクト経験', imgUrl: require('../../../assets/images/services/crm/case1.png') },
      { title: '海外顧客リソース', imgUrl: require('../../../assets/images/services/crm/case2.png') },
      { title: '海外市場のプロモーション', imgUrl: require('../../../assets/images/services/crm/case3.png') }
    ]
  },
  step2: {
    title: 'ProphetCRM如何帮助您?',
    description: '',
    cases: [
      {
        imgUrl: require('../../../assets/images/services/crm/1.png'),
        title: '透明なコミュニケーション',
        description: `ProphetCRMはMicrosoft Outlookに統合され、チームの活動を自動的に追跡・記録します。`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/2.png'),
        title: '効率的な環境',
        description: `ProphetCRMのカスタム自動化により、顧客は迅速で有意義なフィードバックを受け取れます。`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/3.png'),
        title: '使いやすさ',
        description: `Excelに似た操作性により、チームはProphetCRMを日常業務に無理なく導入できます。`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/4.png'),
        title: '強力な分析機能',
        description: `予測と活動の追跡をレポートに統合し、管理者が重要な意思決定を行えるよう支援します。`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/5.png'),
        title: 'カスタマイズ可能なドキュメント',
        description: `ProphetCRMから直接見積書やドキュメント、フォームを生成でき、チームは一つのシステム内で業務を完結できます。`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/6.png'),
        title: '地域を選ばない',
        description: `ProphetCRMはiOSおよびAndroidに対応し、場所を問わず効率的に業務を行えます。`
      }
    ]
  },
  step3: {
    title: 'チームのために設計されたCRM',
    imgUrl: require('../../../assets/images/services/crm/placeholder1.jpg'),
    description: `ProphetCRMはチームのために構築されました。営業やプロジェクトチームが連携して協働でき、コアメンバーと直接やり取りしたり、部門横断の成果進捗を追跡してプロジェクトを期限通りに完了させます。ProphetCRMはOutlook環境で日常業務を継続的に運用できるよう設計されています。`
  },
  step4: {
    title: '私たちが重視すること',
    secondTitle: '顧客は常に最優先',
    description: `私たちはパートナーと長期的な協力関係を築きたいと考えています。ProphetCRMは企業の内部管理課題を解決し、ビジネスパートナーのための顧客管理システムとして、長期的な価値提供を支援します`,
    cases: [
      {
        imgUrl: require('../../../assets/images/services/crm/a.png'),
        title: '実現',
          description: `私たちのプロジェクトチームは貴社のビジネスモデルを理解し、ProphetCRMが業務プロセスを正確に反映するよう努めます。`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/b.png'),
        title: 'サポート',
          description: `弊社の優秀なスタッフを誇りに思っています`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/c.png'),
        title: '顧客の成功',
          description: `導入後はカスタマーサクセスマネージャーがアカウントに割り当てられ、継続的な価値を提供します`
      },
      {
        imgUrl: require('../../../assets/images/services/crm/d.png'),
        title: '統合',
          description: `公開APIにより、ProphetCRMは既存のERPプラットフォームと統合でき、基幹システムとの連携を実現します`
      }
    ]
  },
  step5: {
    title: '技術的詳細と互換性',
    imgUrl: require('../../../assets/images/services/crm/placeholder2.jpg'),
    description: `クラウドおよび冗長化ソリューションを提供し、ニーズに応じた環境を構築します。さらに、ProphetCRMはMicrosoft Office 365と完全互換です。モバイルアプリは主要なプラットフォームで使いやすく設計されています。SOC-2やGDPRに準拠しています。<br/>既存の旧式CRMやExcelスプレッドシートにある重要な顧客データをお持ちですか？データ移行チームが協力して、履歴データを新システムに確実に反映します。`
  }
}
